    document.addEventListener('alpine:init', () => {
        Alpine.data('guestOrderTracking', () => ({
            // ---------- form ----------
            emailOrPhone: '',
            orderNumber: '',
            loading: false,
            error: null,
            view: 'form', // form | order | return | cancel
            orderData: null,
            statusData: null,
            hasStatusData: false,
            productMeta: {},
            orderItemsByLineId: {},
            kutuToParent: {},

            // ---------- sipariş görünümü ----------
            displayItems: [],
            payment: null,
            isSingleHavalePayment: false,
            isHavaleReceived: false,
            hasOneOrderData: false,
            topInvoice: null,
            topTracking: null,
            hasAtLeastOneRefundableItem: false,
            hasAtLeastOneCancellableItem: false,
            isAllItemsRefundTimedOut: false,
            summary: null,
            showDetailPopup: false,
            activeGroup: null,
            activeItem: null,

            // ---------- iade görünümü (hp-order--return paritesi) ----------
            refundableItems: [],
            hasGiftOrder: false,
            keseAutoSelected: false,
            campaignGiftAutoSelected: false,
            keseAutoNote: GUEST_T.keseAutoNote,
            kutuAutoNote: GUEST_T.kutuAutoNote,
            campaignAutoNote: GUEST_T.campaignAutoNote,
            keseEligibleTotalQty: 0,
            campaignEligibleTotalAmount: 0,
            campaignEligibleTotalCount: 0,
            totalRefundableCount: 0,
            isSendReturnButtonLoading: false,
            returnErrorMessages: [],
            approvalModalErrorMessages: [],
            totalRefundAmount: 0,
            itemsRefundAmount: 0,
            addCargoPrice: false,
            acceptedTerms: false,
            selectedCargoCompany: null,
            cargoCompanies: [
                /*{
                id: 'kargola',
                name: 'Kargola',
                cargoProviderId: '052dc6ca-2011-4098-9265-7bc2ac14d3a8',
                cargoCompanyId: 11
                },*/
                /*{
                id: 'dhl',
                name: 'DHL',
                cargoProviderId: 'a6852360-2924-4599-bd00-f2a694802e9e',
                cargoCompanyId: 1
                },*/
                {
                    id: 'surat',
                    name: 'Sürat Kargo',
                    cargoProviderId: 'a1a4fe77-fca2-4637-baa7-31c50febd8ec',
                    cargoCompanyId: 7
                }
            ],
            rmaCode: '',
            rmaUrl: '',
            showReturnTermsModal: false,
            showApprovalModal: false,
            showSuccessModal: false,

            // ---------- iptal görünümü (hp-order--cancel paritesi) ----------
            cancelableItems: [],
            cancelKeseAutoSelected: false,
            cancelCampaignGiftAutoSelected: false,
            cancelKeseAutoNote: GUEST_T.cancelKeseAutoNote,
            cancelKutuAutoNote: GUEST_T.cancelKutuAutoNote,
            cancelCampaignAutoNote: GUEST_T.cancelCampaignAutoNote,
            cancelKeseEligibleTotalQty: 0,
            cancelCampaignEligibleTotalAmount: 0,
            cancelCampaignEligibleTotalCount: 0,
            totalCancelableCount: 0,
            isSendCancelButtonLoading: false,
            cancelErrorMessages: [],
            cancelApprovalModalErrorMessages: [],
            cancelTotalRefundAmount: 0,
            cancelItemsRefundAmount: 0,
            cancelAddCargoPrice: false,
            acceptedCancelTerms: false,
            showCancelTermsModal: false,
            showCancelApprovalModal: false,
            showCancelSuccessModal: false,

            init() {
                this.$watch('view', () => {
                    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
                });
            },

            // =========================================================
            // Form
            // =========================================================
            get isValid() {
                return this.emailOrPhone.trim() !== '' && this.orderNumber.trim() !== '';
            },

            phoneOrEmailMask(input) {
                const first = (input || '').charAt(0);
                return ['+', '9', '0', '5'].includes(first) ? '0999 999 99 99' : false;
            },

            async getOrder() {
                if (!this.isValid) return;

                this.error = null;

                const isEmail = this.emailOrPhone.includes('@');
                const phone = '9' + this.emailOrPhone.replace(/\D/g, '');

                if (isEmail) {
                    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.emailOrPhone.trim())) {
                        this.error = 'E-posta formatı hatalı. Lütfen geçerli bir e-posta adresi giriniz.';
                        return;
                    }
                } else if (phone.length !== 12 || !/^905\d{9}$/.test(phone)) {
                    this.error = 'Telefon numarası formatı hatalı. Lütfen 05xx xxx xx xx şeklinde yazınız.';
                    return;
                }

                this.loading = true;

                try {
                    const payload = isEmail
                        ? { Email: this.emailOrPhone.trim(), OrderNumber: this.orderNumber }
                        : { phone: phone, OrderNumber: this.orderNumber };

                    const res = await fetch(HC_API.GET_GUEST_ORDER, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload),
                    });

                    const json = await res.json();

                    if (res.ok && json?.isSuccess && json?.data) {
                        this.orderData = json.data;
                        await this.prepareOrder();
                        this.view = 'order';
                    } else {
                        this.error = GUEST_T.orderNotFound;
                    }
                } catch (e) {
                    console.error('[guest-order] getOrder error:', e);
                    this.error = GUEST_T.genericError;
                } finally {
                    this.loading = false;
                }
            },

            // İade/iptal talebi sonrası siparişi tazeler (statüler backend'de değişir).
            async refreshOrder() {
                this.showSuccessModal = false;
                this.showCancelSuccessModal = false;
                this.view = 'order';
                await this.getOrder();
            },

            reset() {
                this.view = 'form';
                this.emailOrPhone = '';
                this.orderNumber = '';
                this.error = null;
                this.orderData = null;
                this.statusData = null;
                this.hasStatusData = false;
                this.productMeta = {};
                this.displayItems = [];
                this.refundableItems = [];
                this.cancelableItems = [];
                this.hasAtLeastOneCancellableItem = false;
                this.summary = null;
                this.payment = null;
                this.showDetailPopup = false;
                this.activeItem = null;
                this.activeGroup = null;
            },

            handleSetView(view) {
                this.view = view;
            },
            handleSetMainView() {
                this.view = 'order';
            },

            // =========================================================
            // Yardımcılar
            // =========================================================
            gidToId(gid) {
                const id = Number(String(gid || '').split('/').pop());
                return Number.isFinite(id) && id > 0 ? id : null;
            },

            formatPrice(price) {
                return new Intl.NumberFormat('tr-TR', {
                    style: 'decimal',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(Number(price || 0)) + ' TL';
            },

            formatDate(dateString) {
                if (!dateString) return '';
                return new Intl.DateTimeFormat('tr-TR', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                }).format(new Date(dateString));
            },

            formatShortDate(dateString) {
                if (!dateString) return '';
                return new Intl.DateTimeFormat('tr-TR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }).format(new Date(dateString));
            },

            imgUrl(url, width) {
                if (!url) return GUEST_PLACEHOLDER_IMAGE;
                try {
                    const u = new URL(url, window.location.origin);
                    u.searchParams.set('width', String(width));
                    return u.toString();
                } catch (e) {
                    return url;
                }
            },

            productCountText(count) {
                return GUEST_T.productCountTemplate.replace('@@', String(count));
            },

            getOrderMeta(namespace, key) {
                const m = (this.orderData?.metafields || []).find(
                    meta => meta.namespace === namespace && meta.key === key
                );
                return m ? m.value : '';
            },

            getShippingCityLine() {
                const parts = [];
                const neighbourhood = this.getOrderMeta('hollyaccount', 'shippingneighbourhood');
                const district = this.getOrderMeta('hollyaccount', 'shippingdistrict');
                const city = this.getOrderMeta('hollyaccount', 'shippingcity');
                if (neighbourhood) parts.push(neighbourhood);
                if (district) parts.push(district);
                if (city) parts.push(city);
                return parts.join(' / ') || (this.orderData?.shippingAddress?.city || '');
            },

            getBillingCityLine() {
                const district = this.getOrderMeta('hollyaccount', 'billingdistrict') || this.getOrderMeta('hollyaccount', 'shippingdistrict');
                const city = this.getOrderMeta('hollyaccount', 'billingcity') || this.getOrderMeta('hollyaccount', 'shippingcity');
                if (district && city) return district + ' / ' + city;
                return this.orderData?.billingAddress?.city || '';
            },

            get isInternationalOrder() {
                const country = String(this.orderData?.shippingAddress?.country || '').toLowerCase();
                return country !== '' && !['turkey', 'türkiye', 'tr'].includes(country);
            },

            unitFinalTL(item) {
                return Number(item?.discountedUnitPriceAfterAllDiscountsSet?.presentmentMoney?.amount ?? 0);
            },
            unitOriginalTL(item) {
                return Number(item?.originalUnitPriceSet?.presentmentMoney?.amount ?? 0);
            },
            lineTotalTL(item) {
                return Number(item?.discountedTotalSet?.presentmentMoney?.amount ?? 0);
            },

            isKeseOrderItem(item) {
                return GUEST_KESE_VARIANT_ID != null && this.gidToId(item?.variant?.id) === GUEST_KESE_VARIANT_ID;
            },
            isCampaignGiftOrderItem(item) {
                return GUEST_CAMPAIGN_PRODUCT_ID != null && this.gidToId(item?.product?.id) === GUEST_CAMPAIGN_PRODUCT_ID;
            },

            paymentMethodText(method) {
                switch (method) {
                    case 'CreditCard': return GUEST_T.creditCard;
                    case 'BankTransfer': return GUEST_T.bankTransfer;
                    case 'Cash': return GUEST_T.cash;
                    default: return GUEST_T.other;
                }
            },

            // =========================================================
            // Sipariş verisini hazırlama
            // =========================================================
            parseStatusMetafield() {
                const meta = (this.orderData?.metafields || []).find(
                    m => m.namespace === 'hollyconnect' && m.key === 'order_status'
                );
                if (!meta) return null;
                try {
                    const data = JSON.parse(meta.value);
                    return data && Array.isArray(data.Items) ? data : null;
                } catch (e) {
                    console.error('[guest-order] order_status parse error:', e);
                    return null;
                }
            },

            async prepareOrder() {
                this.statusData = this.parseStatusMetafield();
                this.hasStatusData = !!this.statusData;

                const byLineId = {};
                (this.orderData.orderItems || []).forEach(item => {
                    const id = this.gidToId(item.id);
                    if (id) byLineId[id] = item;
                });
                this.orderItemsByLineId = byLineId;

                await this.loadProductMeta();
                this.computeKutuPairing();
                this.buildPayment();
                this.buildDisplayItems();
                this.buildSummary();
                this.buildRefundableItems();
                this.buildCancellableItems();
            },

            // Theme-taraflı ürün metadata'sı: verilecek_kutu / verilecek_kese / kampanya koleksiyonu.
            // Section Rendering API ile ürün context'inde render edilir.
            async loadProductMeta() {
                this.productMeta = {};
                const handles = [...new Set(
                    (this.orderData.orderItems || []).map(i => i.product?.handle).filter(Boolean)
                )];
                await Promise.all(handles.map(async (handle) => {
                    try {
                        const res = await fetch('/products/' + handle + '?section_id=' + GUEST_PRODUCT_META_SECTION_ID);
                        if (!res.ok) return;
                        const text = await res.text();
                        const doc = new DOMParser().parseFromString(text, 'text/html');
                        const dataEl = doc.getElementById('api-guest-product-meta-data');
                        if (dataEl) this.productMeta[handle] = JSON.parse(dataEl.textContent);
                    } catch (e) {
                        console.error('[guest-order] product meta fetch failed:', handle, e);
                    }
                }));
            },

            metaFor(item) {
                return this.productMeta[item?.product?.handle] || null;
            },

            // ---- Kutu pairing (sıralı 1:1 claim — main-order.liquid algoritmasının JS karşılığı) ----
            // 1) verilecek_kutu metafield'ı dolu ürünlerin satırları parent adaylarıdır.
            // 2) Satır toplamı 0 TL VE sku, bir parent ref'ine tam eşit ya da "<ref>-" prefix'li
            //    satırlar kutu adayıdır; her kutu ilk sahipsiz parent'ı claim eder.
            computeKutuPairing() {
                this.kutuToParent = {};
                const items = this.orderData.orderItems || [];
                const parentRecords = [];
                items.forEach(item => {
                    const meta = this.metaFor(item);
                    if (meta?.verilecek_kutu) {
                        parentRecords.push({ lineId: this.gidToId(item.id), ref: String(meta.verilecek_kutu), claimed: false });
                    }
                });
                if (!parentRecords.length) return;
                items.forEach(item => {
                    if (this.lineTotalTL(item) !== 0) return;
                    const sku = String(item.sku || '');
                    if (!sku) return;
                    if (this.isKeseOrderItem(item) || this.isCampaignGiftOrderItem(item)) return;
                    const parent = parentRecords.find(p => !p.claimed && (sku === p.ref || sku.startsWith(p.ref + '-')));
                    if (parent) {
                        parent.claimed = true;
                        this.kutuToParent[this.gidToId(item.id)] = parent.lineId;
                    }
                });
            },

            isKutuLineId(lineId) {
                return Object.prototype.hasOwnProperty.call(this.kutuToParent, lineId);
            },
            kutuChildrenOf(lineId) {
                return Object.entries(this.kutuToParent)
                    .filter(([, parentId]) => parentId === lineId)
                    .map(([kutuId]) => this.orderItemsByLineId[Number(kutuId)])
                    .filter(Boolean);
            },

            // ---- Ödeme bilgileri (main-order.liquid paritesi: havale özel durumu dahil) ----
            buildPayment() {
                this.payment = null;
                this.isSingleHavalePayment = false;
                this.isHavaleReceived = false;
                const payments = this.statusData?.Payments || [];
                if (!payments.length) return;

                const first = payments[0];
                const isHavale = first.PaymentMethod === 'BankTransfer';
                const data = isHavale ? first : (payments.find(p => p.IsSuccessful) || null);
                if (data) {
                    this.payment = {
                        method: data.PaymentMethod,
                        cardNumber: data.CardNumber || '',
                        bankName: isHavale ? '' : (data.BankName || ''),
                        installment: isHavale ? null : (data.InstallmentCount || null)
                    };
                }
                if (payments.length === 1 && isHavale) {
                    this.isSingleHavalePayment = true;
                    this.isHavaleReceived = !!first.IsSuccessful || this.statusData.Status !== 'Created';
                }
            },

            // Satır bazında etkili statü (talep override'ları dahil)
            lineEffectiveStatus(line) {
                let status = String(line.Status || '').toLowerCase();
                if (line.IsCancelRequested && line.Cancellation && line.Cancellation.IsDenied == null) {
                    status = 'cancelrequest';
                } else if (line.IsRefundRequested && Array.isArray(line.Refunds) && line.Refunds.length > 0) {
                    const lastRefund = line.Refunds[line.Refunds.length - 1];
                    if (line.Status !== 'Refunded' && lastRefund.IsRejected !== true) status = 'refundrequest';
                }
                return status;
            },

            buildDisplayItems() {
                this.displayItems = [];
                this.hasOneOrderData = false;
                this.topInvoice = null;
                this.topTracking = null;
                this.hasAtLeastOneRefundableItem = false;
                this.hasAtLeastOneCancellableItem = false;
                this.isAllItemsRefundTimedOut = false;

                const items = this.orderData.orderItems || [];

                if (!this.hasStatusData) {
                    // Fallback: metafield yoksa düz liste (kutu satırları parent altında rozet olur)
                    this.displayItems = items
                        .filter(i => !this.isKutuLineId(this.gidToId(i.id)))
                        .map(i => this.makeFallbackDisplayItem(i));
                    return;
                }

                // Order genelinde tek fatura/takip verisi + iade zaman aşımı hesapları
                const now = Date.now();
                const allTracking = [];
                const allInvoice = [];
                let refundableCount = 0;
                let timedOutCount = 0;
                let lastTracking = null;
                let lastInvoice = null;

                this.statusData.Items.forEach(hcItem => (hcItem.Lines || []).forEach(line => {
                    if (line.IsCancellable) {
                        this.hasAtLeastOneCancellableItem = true;
                    }
                    if (line.IsRefundable) {
                        refundableCount++;
                        if (line.Tracking && line.Tracking.DeliveredAt) {
                            const diff = (now - new Date(line.Tracking.DeliveredAt).getTime()) / 1000;
                            if (diff > GUEST_REFUND_TIME_LIMIT_SEC) timedOutCount++;
                        } else {
                            this.hasAtLeastOneRefundableItem = true;
                        }
                    }
                    if (line.Tracking && line.Tracking.Code) {
                        allTracking.push(line.Tracking.Code);
                        lastTracking = line.Tracking;
                    }
                    if (line.Invoice && line.Invoice.Code) {
                        allInvoice.push(line.Invoice.Code);
                        lastInvoice = line.Invoice;
                    }
                }));

                if (refundableCount > 0 && refundableCount === timedOutCount) {
                    this.isAllItemsRefundTimedOut = true;
                } else if (refundableCount > 0 && refundableCount > timedOutCount) {
                    this.hasAtLeastOneRefundableItem = true;
                }

                const itemCount = Number(this.orderData.subtotalLineItemsQuantity || 0);
                const uniqTracking = [...new Set(allTracking)];
                const uniqInvoice = [...new Set(allInvoice)];
                this.hasOneOrderData = true;
                if (uniqTracking.length > 1 || uniqInvoice.length > 1) {
                    this.hasOneOrderData = false;
                } else if (allTracking.length !== itemCount || allInvoice.length !== itemCount) {
                    this.hasOneOrderData = false;
                }
                if (this.hasOneOrderData) {
                    this.topTracking = lastTracking;
                    this.topInvoice = lastInvoice;
                }

                this.statusData.Items.forEach(hcItem => {
                    const lineId = this.gidToId(hcItem.ShopifyId);
                    if (this.isKutuLineId(lineId)) return; // kutu, parent altında rozet olarak gösterilir
                    const orderItem = this.orderItemsByLineId[lineId] || null;
                    this.displayItems.push(this.makeDisplayItem(hcItem, orderItem, lineId));
                });
            },

            makeDisplayItem(hcItem, orderItem, lineId) {
                const lines = hcItem.Lines || [];
                const lineTotalQuantity = Math.floor(lines.reduce((s, l) => s + Number(l.Quantity || 1), 0));

                let cancelCount = 0;
                let refundCount = 0;
                lines.forEach(line => {
                    if (line.IsCancelRequested && line.Cancellation && line.Cancellation.IsDenied == null) cancelCount++;
                    if (line.IsRefundRequested && (line.Refunds || []).length > 0) {
                        const lastRefund = line.Refunds[line.Refunds.length - 1];
                        if (line.Status !== 'Refunded' && lastRefund.IsRejected !== true) refundCount++;
                    }
                });

                let status;
                let statusText;
                if (cancelCount > 0 && cancelCount === lineTotalQuantity) {
                    status = 'cancelrequest';
                    statusText = GUEST_FRONT_STATUS_T.cancelrequest;
                } else if (cancelCount > 0) {
                    status = 'partialcancelrequest';
                    statusText = GUEST_FRONT_STATUS_T.partialcancelrequest;
                } else if (refundCount > 0 && refundCount === lineTotalQuantity) {
                    status = 'refundrequest';
                    statusText = GUEST_FRONT_STATUS_T.refundrequest;
                } else if (refundCount > 0) {
                    status = 'partialrefundrequest';
                    statusText = GUEST_FRONT_STATUS_T.partialrefundrequest;
                } else {
                    status = String(hcItem.Status || '').toLowerCase();
                    statusText = GUEST_ITEM_STATUS_T[status] || hcItem.Status || '';
                }

                let statusClass = 'hp:text-green-600';
                if (GUEST_RED_STATUSES.includes(status)) statusClass = 'hp:text-red-600';
                else if (GUEST_ORANGE_STATUSES.includes(status)) statusClass = 'hp:text-orange-400';

                let deliveryDate = '';
                if (status === 'delivered' && lines[0]?.Tracking?.DeliveredAt) {
                    deliveryDate = this.formatShortDate(lines[0].Tracking.DeliveredAt);
                }

                const lineStatuses = [...new Set(lines.map(l => this.lineEffectiveStatus(l)))];
                const hasDifferentLineItems = lineStatuses.length > 1;

                // Gruplamalar — main-order.liquid formatData paritesi
                const invoiceItems = {};
                const trackingItems = {};
                const itemData = {};
                const cancellations = [];
                const refunds = [];
                lines.forEach(line => {
                    const qty = Number(line.Quantity || 1);
                    if (hasDifferentLineItems) {
                        let s = line.Status;
                        if (line.Cancellation && line.Cancellation.IsDenied == null) {
                            s = 'CancelRequest';
                        } else if (line.IsRefundRequested && (line.Refunds || []).length > 0) {
                            const lastRefund = line.Refunds[line.Refunds.length - 1];
                            if (line.Status !== 'Refunded' && lastRefund.IsRejected !== true) s = 'RefundRequest';
                        }
                        if (!itemData[s]) itemData[s] = { status: s, quantity: qty };
                        else itemData[s].quantity += qty;
                    }
                    if (line.Invoice?.Code) {
                        const code = line.Invoice.Code.trim();
                        if (!invoiceItems[code]) invoiceItems[code] = { code, url: line.Invoice.Url, quantity: qty };
                        else invoiceItems[code].quantity += qty;
                    }
                    if (line.Tracking?.Code) {
                        const code = line.Tracking.Code.trim();
                        if (!trackingItems[code]) {
                            trackingItems[code] = {
                                code,
                                url: line.Tracking.Url,
                                company: line.Tracking.Company,
                                createdAt: line.Tracking.CreatedAt,
                                deliveredAt: line.Tracking.DeliveredAt,
                                shipmentStatus: line.ShipmentStatus,
                                quantity: qty
                            };
                        } else {
                            trackingItems[code].quantity += qty;
                        }
                    }
                    if (line.Cancellation) {
                        cancellations.push({
                            reasonDescription: line.Cancellation.ReasonDescription,
                            createdAt: line.Cancellation.CreatedAt,
                            isDenied: line.Cancellation.IsDenied,
                            reasonCode: line.Cancellation.ReasonCode,
                            quantity: qty
                        });
                    }
                    if ((line.Refunds || []).length > 0) {
                        const lastRefund = line.Refunds[line.Refunds.length - 1];
                        refunds.push({
                            reasonCode: lastRefund.ReasonCode,
                            quantity: qty,
                            createdAt: lastRefund.CreatedAt,
                            isShipped: lastRefund.IsShipped,
                            description: lastRefund.Description,
                            rmaCode: lastRefund.RmaCode,
                            rmaUrl: lastRefund.RmaUrl
                        });
                    }
                });

                const invoiceArr = Object.values(invoiceItems);
                const trackingArr = Object.values(trackingItems);
                const unitFinal = orderItem ? this.unitFinalTL(orderItem) : 0;
                const unitOriginal = orderItem ? this.unitOriginalTL(orderItem) : 0;

                return {
                    key: hcItem.Id || String(lineId),
                    lineId,
                    title: orderItem?.name || '',
                    image: orderItem?.image?.url || null,
                    url: orderItem?.product?.handle ? ('/products/' + orderItem.product.handle) : null,
                    sku: orderItem?.sku || '',
                    quantity: orderItem?.quantity || lineTotalQuantity,
                    options: orderItem?.variant?.selectedOptions || [],
                    statusText,
                    statusClass,
                    deliveryDate,
                    unitFinal,
                    unitOriginal,
                    hasDiscount: unitFinal < unitOriginal,
                    hasDifferentLineItems,
                    formattedLineItemData: Object.values(itemData),
                    formattedInvoiceArray: invoiceArr,
                    formattedTrackingArray: trackingArr,
                    formattedCancellationArray: cancellations,
                    formattedRefundArray: refunds,
                    hasInvoiceData: invoiceArr.length > 0,
                    hasTrackingData: trackingArr.length > 0,
                    hasMultipleInvoice: invoiceArr.length > 1,
                    hasMultipleTracking: trackingArr.length > 1,
                    hasCancelRequested: lines.some(l => l.IsCancelRequested && l.Cancellation),
                    hasRefundRequested: lines.some(l => l.IsRefundRequested && (l.Refunds || []).length > 0),
                    shipmentStatus: hcItem.ShipmentStatus,
                    kutuChildren: this.kutuChildrenOf(lineId)
                };
            },

            makeFallbackDisplayItem(orderItem) {
                const lineId = this.gidToId(orderItem.id);
                const unitFinal = this.unitFinalTL(orderItem);
                const unitOriginal = this.unitOriginalTL(orderItem);
                return {
                    key: String(lineId),
                    lineId,
                    title: orderItem.name || '',
                    image: orderItem.image?.url || null,
                    url: orderItem.product?.handle ? ('/products/' + orderItem.product.handle) : null,
                    sku: orderItem.sku || '',
                    quantity: orderItem.quantity || 1,
                    options: orderItem.variant?.selectedOptions || [],
                    statusText: GUEST_ITEM_STATUS_T.created,
                    statusClass: 'hp:text-green-600',
                    deliveryDate: '',
                    unitFinal,
                    unitOriginal,
                    hasDiscount: unitFinal < unitOriginal,
                    hasDifferentLineItems: false,
                    formattedLineItemData: [],
                    formattedInvoiceArray: [],
                    formattedTrackingArray: [],
                    formattedCancellationArray: [],
                    formattedRefundArray: [],
                    hasInvoiceData: false,
                    hasTrackingData: false,
                    hasMultipleInvoice: false,
                    hasMultipleTracking: false,
                    hasCancelRequested: false,
                    hasRefundRequested: false,
                    shipmentStatus: null,
                    kutuChildren: this.kutuChildrenOf(lineId)
                };
            },

            buildSummary() {
                const subtotal = Number(this.orderData.subtotalPriceSet?.presentmentMoney?.amount || 0);
                const totalDiscounts = Number(this.orderData.totalDiscountsSet?.presentmentMoney?.amount || 0);
                const grossShipping = Number(this.orderData.totalShippingPriceSet?.presentmentMoney?.amount || 0);
                // subtotalPriceSet indirimler düşülmüş ürünler toplamıdır.
                // totalShippingPriceSet İNDİRİMSİZ (brüt) kargodur; kargo indirimi
                // totalDiscountsSet içinde gelir. Satırlara dağıtılmış indirimlerin
                // (discountAllocations) toplamı ürün indirimini verir; kalan fark
                // kargo indirimidir ve kargodan düşülür.
                const lineDiscounts = (this.orderData.orderItems || []).reduce((sum, item) =>
                    sum + (item.discountAllocations || []).reduce(
                        (s, a) => s + Number(a?.allocatedAmount?.amount || 0), 0
                    ), 0);
                const shippingDiscount = Math.max(0, totalDiscounts - lineDiscounts);
                const shipping = Math.max(0, grossShipping - shippingDiscount);
                const discounts = lineDiscounts;
                const total = subtotal + shipping;

                // Taksitli ödemede vade farkı (main-order paritesi)
                let displayTotal = total;
                let installmentFee = 0;
                let installmentCount = 0;
                const successfulPayment = (this.statusData?.Payments || []).find(p => p.IsSuccessful);
                if (successfulPayment && Number(successfulPayment.InstallmentCount) > 1 && Number(successfulPayment.Amount) > total) {
                    installmentFee = Number(successfulPayment.Amount) - total;
                    installmentCount = Number(successfulPayment.InstallmentCount);
                    displayTotal = Number(successfulPayment.Amount);
                }

                // İade/iptal edilen tutar (net birim fiyat * line quantity)
                let refundedAmount = 0;
                let activeLineCount = 0;
                if (this.hasStatusData) {
                    this.statusData.Items.forEach(hcItem => {
                        const orderItem = this.orderItemsByLineId[this.gidToId(hcItem.ShopifyId)];
                        (hcItem.Lines || []).forEach(line => {
                            const s = String(line.Status || '').toLowerCase();
                            if (s === 'cancelled' || s === 'refunded') {
                                const qty = Math.max(1, Math.floor(Number(line.Quantity || 1)));
                                if (orderItem) refundedAmount += this.unitFinalTL(orderItem) * qty;
                            } else {
                                activeLineCount++;
                            }
                        });
                    });
                    // Sipariş komple iade/iptal olduysa kargo ücreti de iade edilir
                    // (tam iadede kargo iadesi kuralı — checkForCargoReturnPrice ile tutarlı).
                    if (activeLineCount === 0 && refundedAmount > 0 && shipping > 0) {
                        refundedAmount += shipping;
                    }
                }

                this.summary = {
                    productsTotal: subtotal + discounts,
                    discounts,
                    shipping,
                    isShippingFree: shipping === 0,
                    installmentFee,
                    installmentCount,
                    refundedAmount,
                    displayTotal,
                    netPaid: Math.max(0, displayTotal - refundedAmount)
                };
            },

            openPopup(item, group) {
                this.activeItem = item;
                this.activeGroup = group;
                this.showDetailPopup = true;
            },
            closePopup() {
                this.showDetailPopup = false;
                this.activeItem = null;
                this.activeGroup = null;
            },
            popupTitle() {
                switch (this.activeGroup) {
                    case 'invoice': return GUEST_T.popupBills;
                    case 'tracking': return GUEST_T.popupTracking;
                    case 'cancellation': return GUEST_T.popupCancellation;
                    case 'refund': return GUEST_T.popupRefund;
                    default: return GUEST_T.popupDetails;
                }
            },

            // =========================================================
            // İade akışı — hp-order--return.liquid paritesi
            // =========================================================
            buildRefundableItems() {
                this.refundableItems = [];
                this.hasGiftOrder = false;
                this.keseAutoSelected = false;
                this.campaignGiftAutoSelected = false;
                this.itemsRefundAmount = 0;
                this.totalRefundAmount = 0;
                this.addCargoPrice = false;
                this.acceptedTerms = false;
                this.selectedCargoCompany = null;
                this.returnErrorMessages = [];
                this.approvalModalErrorMessages = [];
                this.rmaCode = '';
                this.rmaUrl = '';
                if (!this.hasStatusData) return;

                const now = Date.now();

                // Aktif (iptal/iade edilmemiş) eligible toplamlar — hp-order--return Liquid hesabının JS karşılığı
                let keseEligibleQty = 0;
                let campaignAmount = 0; // kuruş
                let campaignCount = 0;
                let refundedQty = 0;
                this.statusData.Items.forEach(hcItem => (hcItem.Lines || []).forEach(line => {
                    if (line.Status === 'Refunded') refundedQty += Math.floor(Number(line.Quantity || 1));
                    if (line.Status === 'Cancelled' || line.Status === 'Refunded') return;
                    const orderItem = this.orderItemsByLineId[this.gidToId(line.ShopifyId)];
                    if (!orderItem) return;
                    const meta = this.metaFor(orderItem);
                    const qty = Number(line.Quantity || 1);

                    if (meta?.verilecek_kese && !this.isKeseOrderItem(orderItem)) {
                        keseEligibleQty += qty;
                    }
                    if (GUEST_CAMPAIGN_LOGIC_ENABLED && !this.isCampaignGiftOrderItem(orderItem)) {
                        const inCollection = GUEST_CAMPAIGN_HAS_COLLECTION ? !!meta?.in_campaign_collection : true;
                        if (inCollection) {
                            campaignAmount += Math.round(this.unitFinalTL(orderItem) * 100) * qty;
                            campaignCount += qty;
                        }
                    }
                }));
                this.keseEligibleTotalQty = keseEligibleQty;
                this.campaignEligibleTotalAmount = campaignAmount;
                this.campaignEligibleTotalCount = campaignCount;
                this.totalRefundableCount = Number(this.orderData.subtotalLineItemsQuantity || 0) - refundedQty;

                this.statusData.Items.forEach(hcItem => (hcItem.Lines || []).forEach(line => {
                    if (!line.IsRefundable) return;
                    // zaman aşımı kontrolü
                    if (line.Tracking && line.Tracking.DeliveredAt) {
                        const diff = (now - new Date(line.Tracking.DeliveredAt).getTime()) / 1000;
                        if (diff > GUEST_REFUND_TIME_LIMIT_SEC) return;
                    }
                    const lineId = this.gidToId(line.ShopifyId);
                    const orderItem = this.orderItemsByLineId[lineId];
                    if (!orderItem) return;
                    const meta = this.metaFor(orderItem);

                    const isKese = this.isKeseOrderItem(orderItem);
                    const isKutu = this.isKutuLineId(lineId);
                    const isCampaignGift = GUEST_CAMPAIGN_LOGIC_ENABLED && this.isCampaignGiftOrderItem(orderItem);
                    let isCampaignEligible = false;
                    if (GUEST_CAMPAIGN_LOGIC_ENABLED && !isCampaignGift) {
                        isCampaignEligible = GUEST_CAMPAIGN_HAS_COLLECTION ? !!meta?.in_campaign_collection : true;
                    }

                    this.refundableItems.push({
                        id: lineId,
                        image: orderItem.image?.url || null,
                        price: String(Math.round(this.unitOriginalTL(orderItem) * 100)),
                        finalPrice: String(Math.round(this.unitFinalTL(orderItem) * 100)),
                        title: orderItem.name || '',
                        reason: '',
                        hcItemId: hcItem.Id,
                        optionsWithValues: orderItem.variant?.selectedOptions || [],
                        hcLineItemId: line.Id,
                        hcQuantity: Number(line.Quantity || 1),
                        selected: false,
                        selectedReason: null,
                        shopifyLineId: lineId,
                        isKutu,
                        isKese,
                        isKeseEligible: !!meta?.verilecek_kese && !isKese,
                        isCampaignGift,
                        isCampaignEligible,
                        parentShopifyLineId: isKutu ? this.kutuToParent[lineId] : null
                    });
                }));

                this.sortReturnItems();

                // hasGiftOrder kontrolünde kutu/kese/kampanya hediye otomatik yönetildiğinden hariç tut.
                const userFacingItems = this.refundableItems.filter(i => !i.isKutu && !i.isKese && !i.isCampaignGift);
                this.hasGiftOrder = userFacingItems.length > 0 && userFacingItems.every(item => Number(item.finalPrice) === 0);
                if (this.hasGiftOrder) {
                    this.refundableItems.forEach(item => {
                        item.selected = true;
                        if (this.isPriceContributing(item)) {
                            this.itemsRefundAmount += Number(item.finalPrice / 100) * Number(item.hcQuantity);
                        }
                    });
                    this.checkForCargoReturnPrice();
                }
                this.recomputeKese();
                this.recomputeCampaignGift();
            },

            sortReturnItems() {
                const items = this.refundableItems;
                const keseItems = items.filter(i => i.isKese);
                const kutuItems = items.filter(i => i.isKutu);
                const campaignGiftItems = items.filter(i => i.isCampaignGift);
                const others = items.filter(i => !i.isKutu && !i.isKese && !i.isCampaignGift);
                const result = [];
                others.forEach(parent => {
                    result.push(parent);
                    const myKutus = kutuItems.filter(k => k.parentShopifyLineId === parent.shopifyLineId);
                    result.push(...myKutus);
                });
                const orphans = kutuItems.filter(k => !others.some(o => o.shopifyLineId === k.parentShopifyLineId));
                result.push(...orphans);
                result.push(...keseItems);
                result.push(...campaignGiftItems);
                this.refundableItems = result;
            },

            isPriceContributing(item) {
                return !item.isKutu && !item.isKese && !item.isCampaignGift;
            },

            getRefundableItems() {
                if (this.hasGiftOrder) return this.refundableItems;
                return this.refundableItems.filter(item => item.selected);
            },

            get hasSelectedKutu() {
                return this.refundableItems.some(item => item.isKutu && item.selected);
            },
            get selectedCargoDisplayName() {
                const cargo = this.cargoCompanies.find(c => c.id === this.selectedCargoCompany);
                if (!cargo) return 'Sürat Kargo';
                return cargo.name.includes('Kargo') ? cargo.name : `${cargo.name} Kargo`;
            },
            get shouldShowApprovalNotice() {
                return this.hasSelectedKutu || this.keseAutoSelected || this.campaignGiftAutoSelected;
            },

            addItemAmount(item) {
                if (!this.isPriceContributing(item)) return;
                this.itemsRefundAmount += Number(item.finalPrice / 100) * Number(item.hcQuantity);
            },
            removeItemAmount(item) {
                if (!this.isPriceContributing(item)) return;
                this.itemsRefundAmount -= Number(item.finalPrice / 100) * Number(item.hcQuantity);
            },

            getKutuChildren(parentItem) {
                if (!parentItem || parentItem.isKutu || parentItem.isKese) return [];
                return this.refundableItems.filter(
                    i => i.isKutu && i.parentShopifyLineId === parentItem.shopifyLineId
                );
            },
            getKeseItem() {
                return this.refundableItems.find(i => i.isKese);
            },

            recomputeKese() {
                const keseItem = this.getKeseItem();
                if (!keseItem || !GUEST_KESE_THRESHOLD) {
                    this.keseAutoSelected = false;
                    return;
                }
                const selectedEligibleQty = this.refundableItems
                    .filter(i => i.isKeseEligible && i.selected)
                    .reduce((sum, i) => sum + Number(i.hcQuantity || 1), 0);
                const remaining = this.keseEligibleTotalQty - selectedEligibleQty;
                const shouldAutoSelect = remaining < GUEST_KESE_THRESHOLD;
                if (shouldAutoSelect && !keseItem.selected) {
                    keseItem.selected = true;
                } else if (!shouldAutoSelect && keseItem.selected && !this.hasGiftOrder) {
                    keseItem.selected = false;
                }
                this.keseAutoSelected = shouldAutoSelect;
            },

            // İade edilmeyen kalan ürünler kampanya şartını sağlamıyorsa hediye ürün
            // otomatik iadeye eklenir. Eligibility mantığı api-campaign-calculate ile aynı.
            recomputeCampaignGift() {
                const giftItems = this.refundableItems.filter(i => i.isCampaignGift);
                if (giftItems.length === 0 || !GUEST_CAMPAIGN_LOGIC_ENABLED) {
                    this.campaignGiftAutoSelected = false;
                    return;
                }
                const selected = this.refundableItems.filter(i => i.isCampaignEligible && i.selected);
                const selectedAmount = selected.reduce((sum, i) => sum + Number(i.finalPrice) * Number(i.hcQuantity || 1), 0);
                const selectedCount = selected.reduce((sum, i) => sum + Number(i.hcQuantity || 1), 0);
                const remainingAmount = this.campaignEligibleTotalAmount - selectedAmount;
                const remainingCount = this.campaignEligibleTotalCount - selectedCount;
                let remainingEligible;
                if (GUEST_CAMPAIGN_HAS_THRESHOLD) {
                    remainingEligible = remainingAmount >= GUEST_CAMPAIGN_THRESHOLD;
                } else if (GUEST_CAMPAIGN_HAS_COLLECTION) {
                    remainingEligible = remainingCount >= 1;
                } else {
                    remainingEligible = remainingCount >= 1 && remainingAmount >= 100;
                }
                const shouldAutoSelect = !remainingEligible;
                giftItems.forEach(giftItem => {
                    if (shouldAutoSelect && !giftItem.selected) {
                        giftItem.selected = true;
                    } else if (!shouldAutoSelect && giftItem.selected && !this.hasGiftOrder) {
                        giftItem.selected = false;
                    }
                });
                this.campaignGiftAutoSelected = shouldAutoSelect;
            },

            handleCheckbox(isChecked, hcLineItemId) {
                if (this.hasGiftOrder && !isChecked) return;
                const index = this.refundableItems.findIndex(item => item.hcLineItemId == hcLineItemId);
                if (index === -1) return;
                const item = this.refundableItems[index];
                if (item.isKutu || item.isKese || item.isCampaignGift) return;

                if (isChecked) {
                    item.selected = true;
                    this.addItemAmount(item);
                    this.getKutuChildren(item).forEach(k => {
                        k.selected = true;
                    });
                } else {
                    item.selected = false;
                    item.selectedReason = null;
                    this.removeItemAmount(item);
                    this.getKutuChildren(item).forEach(k => {
                        k.selected = false;
                        k.selectedReason = null;
                    });
                }
                this.recomputeKese();
                this.recomputeCampaignGift();
                this.checkForCargoReturnPrice();
            },

            checkForCargoReturnPrice() {
                const selectedNonZero = this.refundableItems.filter(i => i.selected && this.isPriceContributing(i)).length;
                const expected = this.totalRefundableCount - this.refundableItems.filter(i => !this.isPriceContributing(i)).length;
                if (selectedNonZero === expected && expected > 0 && !this.summary?.isShippingFree) {
                    this.addCargoPrice = true;
                } else {
                    this.addCargoPrice = false;
                }
            },

            handleSelectReason(reason, hcLineItemId) {
                const index = this.refundableItems.findIndex(item => item.hcLineItemId == hcLineItemId);
                if (index === -1) return;
                const item = this.refundableItems[index];
                item.selectedReason = reason;
                this.getKutuChildren(item).forEach(k => {
                    k.selectedReason = reason;
                });
            },

            validateRequest() {
                const refundableItems = this.getRefundableItems();
                const errorMessages = [];
                const userSelectable = refundableItems.filter(i => !i.isKutu && !i.isKese && !i.isCampaignGift);
                if (!this.hasGiftOrder && userSelectable.length === 0) {
                    errorMessages.push(GUEST_T.errSelectProduct);
                }
                if (!this.acceptedTerms) {
                    errorMessages.push(GUEST_T.errAcceptTerms);
                }
                if (!this.selectedCargoCompany) {
                    errorMessages.push(GUEST_T.errSelectCargo);
                }
                userSelectable.forEach(item => {
                    if (!item.selectedReason) {
                        errorMessages.push(item.title + ' ' + GUEST_T.errForRefundReason);
                    }
                });

                if (errorMessages.length > 0) {
                    this.returnErrorMessages = errorMessages;
                    this.$refs.errorContainer?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    return false;
                }
                this.returnErrorMessages = [];
                return true;
            },

            handleSendReturnRequest() {
                const isValidRequest = this.validateRequest();
                if (!isValidRequest) return;
                this.totalRefundAmount = this.addCargoPrice
                    ? this.itemsRefundAmount + Number(this.summary?.shipping || 0)
                    : this.itemsRefundAmount;
                this.approvalModalErrorMessages = [];
                this.showApprovalModal = true;
            },

            get returnItemsPayload() {
                const refundableItems = this.hasGiftOrder ? this.refundableItems : this.getRefundableItems();

                const groupedItems = refundableItems.reduce((acc, item) => {
                    if (!acc[item.hcItemId]) {
                        acc[item.hcItemId] = {
                            OrderItemId: item.hcItemId,
                            Lines: []
                        };
                    }
                    let reasonCode, reasonText;
                    if (item.isKese) {
                        reasonCode = GUEST_KESE_AUTO_REASON.code;
                        reasonText = GUEST_KESE_AUTO_REASON.text;
                    } else if (item.isCampaignGift) {
                        reasonCode = GUEST_CAMPAIGN_AUTO_REASON.code;
                        reasonText = GUEST_CAMPAIGN_AUTO_REASON.text;
                    } else if (item.isKutu) {
                        reasonCode = String(item.selectedReason?.code || GUEST_KESE_AUTO_REASON.code);
                        reasonText = item.selectedReason?.text || GUEST_KESE_AUTO_REASON.text;
                    } else {
                        reasonCode = String(item.selectedReason.code);
                        reasonText = item.selectedReason.text;
                    }

                    acc[item.hcItemId].Lines.push({
                        OrderItemLineId: item.hcLineItemId,
                        ReasonCode: reasonCode,
                        ReasonDescription: reasonText
                    });

                    return acc;
                }, {});

                return Object.values(groupedItems);
            },

            formatDataForRequest() {
                const selectedCargo = this.cargoCompanies.find(
                    (cargo) => cargo.id === this.selectedCargoCompany
                );
                return {
                    OrderId: this.statusData?.Id,
                    WaitForApproval: true,
                    Items: this.returnItemsPayload,
                    CargoProviderId: selectedCargo?.cargoProviderId,
                    CargoCompanyId: selectedCargo?.cargoCompanyId
                };
            },

            async sendReturnRequest() {
                this.isSendReturnButtonLoading = true;
                this.approvalModalErrorMessages = [];
                try {
                    const payload = this.formatDataForRequest();
                    const response = await fetch(HC_API.SEND_GUEST_RETURN_ITEMS, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(payload)
                    });
                    const result = await response.json();
                    if (response.ok && result.isSuccess) {
                        if (!result.data?.isRejected) {
                            this.showApprovalModal = false;
                            this.showSuccessModal = true;
                            this.rmaCode = result.data?.rmaCode;
                            this.rmaUrl = result.data?.rmaUrl;
                        } else {
                            this.approvalModalErrorMessages.push(result.data?.rejectDescription || GUEST_T.errUnexpected);
                        }
                    } else {
                        this.approvalModalErrorMessages.push(result?.data?.rejectDescription || GUEST_T.errUnexpected);
                    }
                } catch (error) {
                    console.error('error', error);
                    this.approvalModalErrorMessages.push(GUEST_T.errUnexpected);
                } finally {
                    this.isSendReturnButtonLoading = false;
                }
            },

            // =========================================================
            // İptal akışı — hp-order--cancel.liquid paritesi
            // =========================================================
            buildCancellableItems() {
                this.cancelableItems = [];
                this.cancelKeseAutoSelected = false;
                this.cancelCampaignGiftAutoSelected = false;
                this.cancelItemsRefundAmount = 0;
                this.cancelTotalRefundAmount = 0;
                this.cancelAddCargoPrice = false;
                this.acceptedCancelTerms = false;
                this.cancelErrorMessages = [];
                this.cancelApprovalModalErrorMessages = [];
                this.showCancelTermsModal = false;
                this.showCancelApprovalModal = false;
                this.showCancelSuccessModal = false;
                if (!this.hasStatusData) return;

                let keseEligibleQty = 0;
                let campaignAmount = 0;
                let campaignCount = 0;
                let cancelledQty = 0;
                this.statusData.Items.forEach(hcItem => (hcItem.Lines || []).forEach(line => {
                    if (line.Status === 'Cancelled') cancelledQty += Math.floor(Number(line.Quantity || 1));
                    if (line.Status === 'Cancelled' || line.Status === 'Refunded') return;
                    const orderItem = this.orderItemsByLineId[this.gidToId(line.ShopifyId)];
                    if (!orderItem) return;
                    const meta = this.metaFor(orderItem);
                    const qty = Number(line.Quantity || 1);

                    if (meta?.verilecek_kese && !this.isKeseOrderItem(orderItem)) {
                        keseEligibleQty += qty;
                    }
                    if (GUEST_CAMPAIGN_LOGIC_ENABLED && !this.isCampaignGiftOrderItem(orderItem)) {
                        const inCollection = GUEST_CAMPAIGN_HAS_COLLECTION ? !!meta?.in_campaign_collection : true;
                        if (inCollection) {
                            campaignAmount += Math.round(this.unitFinalTL(orderItem) * 100) * qty;
                            campaignCount += qty;
                        }
                    }
                }));
                this.cancelKeseEligibleTotalQty = keseEligibleQty;
                this.cancelCampaignEligibleTotalAmount = campaignAmount;
                this.cancelCampaignEligibleTotalCount = campaignCount;
                this.totalCancelableCount = Number(this.orderData.subtotalLineItemsQuantity || 0) - cancelledQty;

                this.statusData.Items.forEach(hcItem => (hcItem.Lines || []).forEach(line => {
                    if (!line.IsCancellable) return;
                    const lineId = this.gidToId(line.ShopifyId);
                    const orderItem = this.orderItemsByLineId[lineId];
                    if (!orderItem) return;
                    const meta = this.metaFor(orderItem);

                    const isKese = this.isKeseOrderItem(orderItem);
                    const isKutu = this.isKutuLineId(lineId);
                    const isCampaignGift = GUEST_CAMPAIGN_LOGIC_ENABLED && this.isCampaignGiftOrderItem(orderItem);
                    let isCampaignEligible = false;
                    if (GUEST_CAMPAIGN_LOGIC_ENABLED && !isCampaignGift) {
                        isCampaignEligible = GUEST_CAMPAIGN_HAS_COLLECTION ? !!meta?.in_campaign_collection : true;
                    }

                    this.cancelableItems.push({
                        id: lineId,
                        image: orderItem.image?.url || null,
                        price: String(Math.round(this.unitOriginalTL(orderItem) * 100)),
                        finalPrice: String(Math.round(this.unitFinalTL(orderItem) * 100)),
                        title: orderItem.name || '',
                        reason: '',
                        hcItemId: hcItem.Id,
                        optionsWithValues: orderItem.variant?.selectedOptions || [],
                        hcLineItemId: line.Id,
                        hcQuantity: Number(line.Quantity || 1),
                        selected: false,
                        selectedReason: null,
                        shopifyLineId: lineId,
                        isKutu,
                        isKese,
                        isKeseEligible: !!meta?.verilecek_kese && !isKese,
                        isCampaignGift,
                        isCampaignEligible,
                        parentShopifyLineId: isKutu ? this.kutuToParent[lineId] : null
                    });
                }));

                this.sortCancelItems();
                this.recomputeCancelKese();
                this.recomputeCancelCampaignGift();
            },

            sortCancelItems() {
                const items = this.cancelableItems;
                const keseItems = items.filter(i => i.isKese);
                const kutuItems = items.filter(i => i.isKutu);
                const campaignGiftItems = items.filter(i => i.isCampaignGift);
                const others = items.filter(i => !i.isKutu && !i.isKese && !i.isCampaignGift);
                const result = [];
                others.forEach(parent => {
                    result.push(parent);
                    const myKutus = kutuItems.filter(k => k.parentShopifyLineId === parent.shopifyLineId);
                    result.push(...myKutus);
                });
                const orphans = kutuItems.filter(k => !others.some(o => o.shopifyLineId === k.parentShopifyLineId));
                result.push(...orphans);
                result.push(...keseItems);
                result.push(...campaignGiftItems);
                this.cancelableItems = result;
            },

            getCancelableItems() {
                return this.cancelableItems.filter(item => item.selected);
            },

            get hasSelectedCancelKutu() {
                return this.cancelableItems.some(item => item.isKutu && item.selected);
            },
            get shouldShowCancelApprovalNotice() {
                return this.hasSelectedCancelKutu || this.cancelKeseAutoSelected || this.cancelCampaignGiftAutoSelected;
            },

            addCancelItemAmount(item) {
                if (!this.isPriceContributing(item)) return;
                this.cancelItemsRefundAmount += Number(item.finalPrice / 100) * Number(item.hcQuantity);
            },
            removeCancelItemAmount(item) {
                if (!this.isPriceContributing(item)) return;
                this.cancelItemsRefundAmount -= Number(item.finalPrice / 100) * Number(item.hcQuantity);
            },

            getCancelKutuChildren(parentItem) {
                if (!parentItem || parentItem.isKutu || parentItem.isKese) return [];
                return this.cancelableItems.filter(
                    i => i.isKutu && i.parentShopifyLineId === parentItem.shopifyLineId
                );
            },
            getCancelKeseItem() {
                return this.cancelableItems.find(i => i.isKese);
            },

            recomputeCancelKese() {
                const keseItem = this.getCancelKeseItem();
                if (!keseItem || !GUEST_KESE_THRESHOLD) {
                    this.cancelKeseAutoSelected = false;
                    return;
                }
                const selectedEligibleQty = this.cancelableItems
                    .filter(i => i.isKeseEligible && i.selected)
                    .reduce((sum, i) => sum + Number(i.hcQuantity || 1), 0);
                const remaining = this.cancelKeseEligibleTotalQty - selectedEligibleQty;
                const shouldAutoSelect = remaining < GUEST_KESE_THRESHOLD;
                if (shouldAutoSelect && !keseItem.selected) {
                    keseItem.selected = true;
                } else if (!shouldAutoSelect && keseItem.selected) {
                    keseItem.selected = false;
                }
                this.cancelKeseAutoSelected = shouldAutoSelect;
            },

            recomputeCancelCampaignGift() {
                const giftItems = this.cancelableItems.filter(i => i.isCampaignGift);
                if (giftItems.length === 0 || !GUEST_CAMPAIGN_LOGIC_ENABLED) {
                    this.cancelCampaignGiftAutoSelected = false;
                    return;
                }
                const selected = this.cancelableItems.filter(i => i.isCampaignEligible && i.selected);
                const selectedAmount = selected.reduce((sum, i) => sum + Number(i.finalPrice) * Number(i.hcQuantity || 1), 0);
                const selectedCount = selected.reduce((sum, i) => sum + Number(i.hcQuantity || 1), 0);
                const remainingAmount = this.cancelCampaignEligibleTotalAmount - selectedAmount;
                const remainingCount = this.cancelCampaignEligibleTotalCount - selectedCount;
                let remainingEligible;
                if (GUEST_CAMPAIGN_HAS_THRESHOLD) {
                    remainingEligible = remainingAmount >= GUEST_CAMPAIGN_THRESHOLD;
                } else if (GUEST_CAMPAIGN_HAS_COLLECTION) {
                    remainingEligible = remainingCount >= 1;
                } else {
                    remainingEligible = remainingCount >= 1 && remainingAmount >= 100;
                }
                const shouldAutoSelect = !remainingEligible;
                giftItems.forEach(giftItem => {
                    if (shouldAutoSelect && !giftItem.selected) {
                        giftItem.selected = true;
                    } else if (!shouldAutoSelect && giftItem.selected) {
                        giftItem.selected = false;
                    }
                });
                this.cancelCampaignGiftAutoSelected = shouldAutoSelect;
            },

            handleCancelCheckbox(isChecked, hcLineItemId) {
                const index = this.cancelableItems.findIndex(item => item.hcLineItemId == hcLineItemId);
                if (index === -1) return;
                const item = this.cancelableItems[index];
                if (item.isKutu || item.isKese || item.isCampaignGift) return;

                if (isChecked) {
                    item.selected = true;
                    this.addCancelItemAmount(item);
                    this.getCancelKutuChildren(item).forEach(k => {
                        k.selected = true;
                    });
                } else {
                    item.selected = false;
                    item.selectedReason = null;
                    this.removeCancelItemAmount(item);
                    this.getCancelKutuChildren(item).forEach(k => {
                        k.selected = false;
                        k.selectedReason = null;
                    });
                }
                this.recomputeCancelKese();
                this.recomputeCancelCampaignGift();
                this.checkForCargoCancelPrice();
            },

            checkForCargoCancelPrice() {
                const selectedNonZero = this.cancelableItems.filter(i => i.selected && this.isPriceContributing(i)).length;
                const expected = this.totalCancelableCount - this.cancelableItems.filter(i => !this.isPriceContributing(i)).length;
                if (selectedNonZero === expected && expected > 0 && !this.summary?.isShippingFree) {
                    this.cancelAddCargoPrice = true;
                } else {
                    this.cancelAddCargoPrice = false;
                }
            },

            handleCancelSelectReason(reason, hcLineItemId) {
                const index = this.cancelableItems.findIndex(item => item.hcLineItemId == hcLineItemId);
                if (index === -1) return;
                const item = this.cancelableItems[index];
                item.selectedReason = reason;
                this.getCancelKutuChildren(item).forEach(k => {
                    k.selectedReason = reason;
                });
            },

            validateCancelRequest() {
                const cancelableItems = this.getCancelableItems();
                const errorMessages = [];
                const userSelectable = cancelableItems.filter(i => !i.isKutu && !i.isKese && !i.isCampaignGift);
                if (userSelectable.length === 0) {
                    errorMessages.push(GUEST_T.cancelErrSelectProduct);
                }
                if (!this.acceptedCancelTerms) {
                    errorMessages.push(GUEST_T.cancelErrAcceptTerms);
                }
                userSelectable.forEach(item => {
                    if (!item.selectedReason) {
                        errorMessages.push(item.title + ' ' + GUEST_T.cancelErrForReason);
                    }
                });

                if (errorMessages.length > 0) {
                    this.cancelErrorMessages = errorMessages;
                    this.$refs.cancelErrorContainer?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    return false;
                }
                this.cancelErrorMessages = [];
                return true;
            },

            handleSendCancelRequest() {
                const isValidRequest = this.validateCancelRequest();
                if (!isValidRequest) return;
                this.cancelTotalRefundAmount = this.cancelAddCargoPrice
                    ? this.cancelItemsRefundAmount + Number(this.summary?.shipping || 0)
                    : this.cancelItemsRefundAmount;
                this.cancelApprovalModalErrorMessages = [];
                this.showCancelApprovalModal = true;
            },

            get cancelItemsPayload() {
                const cancelableItems = this.getCancelableItems();

                const groupedItems = cancelableItems.reduce((acc, item) => {
                    if (!acc[item.hcItemId]) {
                        acc[item.hcItemId] = {
                            OrderItemId: item.hcItemId,
                            Lines: []
                        };
                    }
                    let reasonText;
                    if (item.isKese) {
                        reasonText = GUEST_CANCEL_KESE_AUTO_REASON.text;
                    } else if (item.isCampaignGift) {
                        reasonText = GUEST_CANCEL_CAMPAIGN_AUTO_REASON.text;
                    } else if (item.isKutu) {
                        reasonText = item.selectedReason?.text || GUEST_CANCEL_KESE_AUTO_REASON.text;
                    } else {
                        reasonText = item.selectedReason?.text;
                    }

                    acc[item.hcItemId].Lines.push({
                        OrderItemLineId: item.hcLineItemId,
                        ReasonCode: '1',
                        ReasonDescription: reasonText
                    });

                    return acc;
                }, {});

                return Object.values(groupedItems);
            },

            formatCancelDataForRequest() {
                return {
                    OrderId: this.statusData?.Id,
                    Items: this.cancelItemsPayload
                };
            },

            async sendCancelRequest() {
                this.isSendCancelButtonLoading = true;
                this.cancelApprovalModalErrorMessages = [];
                try {
                    const payload = this.formatCancelDataForRequest();
                    const response = await fetch(HC_API.SEND_GUEST_CANCEL_ITEMS, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(payload)
                    });
                    const result = await response.json();
                    if (response.ok && result.isSuccess) {
                        if (!result.data?.isRejected) {
                            this.showCancelApprovalModal = false;
                            this.showCancelSuccessModal = true;
                        } else {
                            this.cancelApprovalModalErrorMessages.push(result.data?.rejectDescription || GUEST_CANCEL_DEFAULT_ERROR);
                        }
                    } else {
                        this.cancelApprovalModalErrorMessages.push(result?.data?.rejectDescription || GUEST_CANCEL_DEFAULT_ERROR);
                    }
                } catch (error) {
                    console.error('error', error);
                    this.cancelApprovalModalErrorMessages.push(GUEST_CANCEL_DEFAULT_ERROR);
                } finally {
                    this.isSendCancelButtonLoading = false;
                }
            }
        }));
    });
